import type { ReactElement } from 'react';
import { Navigate, useParams } from 'react-router';
import { GetStartedPage } from './GetStartedPage';
import { McpDocsPage } from './McpDocsPage';
import { RequestAccessDocsPage } from './RequestAccessDocsPage';
import { TasksDocsPage } from './TasksDocsPage';
import { AgentsDocsPage } from './AgentsDocsPage';
import { SecurelinkDocsPage } from './SecurelinkDocsPage';
import { VpnSubnetsDocsPage } from './VpnSubnetsDocsPage';
import { ConnectionAuditDocsPage } from './ConnectionAuditDocsPage';
import { SecurelinkTcpRelayDocsPage } from './SecurelinkTcpRelayDocsPage';
import { SecurelinkDeviceProvisionDocsPage } from './SecurelinkDeviceProvisionDocsPage';
import { TransforgeDocsPage } from './TransforgeDocsPage';
import { TransforgeMultiCloudDocsPage } from './TransforgeMultiCloudDocsPage';
import { TransforgeClientsDocsPage } from './TransforgeClientsDocsPage';
import { TransforgeOperationsDocsPage } from './TransforgeOperationsDocsPage';

/**
 * Unified documentation surface. This is an AI-agent-first system, so the docs
 * — Get Started (connect an agent), how to request access, and the MCP tool
 * reference — are grouped under one /docs route. The section menu lives in the
 * app's left sidebar (App.tsx); this component just renders the active section.
 * Section metadata (slugs/labels) is shared via lib/docs → DOC_SECTIONS.
 */
const ELEMENTS: Record<string, ReactElement> = {
  'get-started': <GetStartedPage />,
  'request-access': <RequestAccessDocsPage />,
  tasks: <TasksDocsPage />,
  mcp: <McpDocsPage />,
  agents: <AgentsDocsPage />,
  securelink: <SecurelinkDocsPage />,
  'vpn-subnets': <VpnSubnetsDocsPage />,
  'connection-audit': <ConnectionAuditDocsPage />,
  'securelink-tcp-relay': <SecurelinkTcpRelayDocsPage />,
  'securelink-device-provision': <SecurelinkDeviceProvisionDocsPage />,
  transforge: <TransforgeDocsPage />,
  'transforge-multi-cloud': <TransforgeMultiCloudDocsPage />,
  'transforge-clients': <TransforgeClientsDocsPage />,
  'transforge-operations': <TransforgeOperationsDocsPage />,
};

export function DocsPage() {
  const { section } = useParams();
  const el = section ? ELEMENTS[section] : undefined;
  if (!el) return <Navigate to="/docs/get-started" replace />;

  // .docs-content scopes the docs reading-column styling (globals.css).
  return <div className="docs-content">{el}</div>;
}
